import React, { useState, useEffect} from 'react';
import './css/App.css';
import { SpinnerComp } from './helper/spinner';
import { Button, Container, Row, Col } from 'react-bootstrap'
import Talk from './helper/Talk'
import { postMultipartWithFileResponse } from './utilities/NetUtilities';
import { buildUrl } from './helper/handler';

function DatiPerSede() {

    const [message, setMessage] = useState([]);
    const [warning, setWarning] = useState([]);
    const [error, setError] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedFile, setSelectedFile] = useState("");
    const [isFilePicked, setIsFilePicked] = useState("");
    const [inputKey, setInputKey] = useState(Date.now());
    const [nomeOrganizzazione, setNomeOrganizzazione] = useState("")
    const [tipoOrganizzazione, setTipoOrganizzazione] = useState("")

    const datiSede = "datisede";
    const url_dati_sede = "uploaddatisede";

    useEffect(() => {
        const init = async () => {
            const organizzazioneMap = JSON.parse(window.sessionStorage.getItem("organizzazione"))
            setNomeOrganizzazione(organizzazioneMap.nome)
            setTipoOrganizzazione(organizzazioneMap.tipo)
        }   
        init();
      }, [])

    const changeHandler = (event) => {
        setSelectedFile(event.target.files[0]);
        setIsFilePicked(event.target.name);
        setMessage([]);
        setWarning([]);
        setError([]);
    };

    const okAction = (data) => {
        setLoading(false)
        const errori = [];
        const warning = [];
        const messaggi = [];
        data.messaggi.forEach((actual) => {
            if (actual.tipo === 'danger') {
                errori.push(actual.descrizione);
            }
            if (actual.tipo === 'warning') {
                warning.push(actual.descrizione);
            }
            if (actual.tipo === 'info') {
                messaggi.push(actual.descrizione);
            }
        })
        
        setMessage(messaggi);
        setWarning(warning);
        setError(errori);
    }

    const nokAction = (data) => {
        setLoading(false)
        setMessage([]);
        if(data.messaggi[0].tipo === "warning") {
            setWarning([data.messaggi[0].descrizione]);
        } else {
            setError([data.messaggi[0].descrizione]);
        }
    }

    // Callback per quando viene scaricato il file
    const onFileDownload = (response) => {
        setLoading(false);
        setMessage([response.message]);
        setWarning([]);
        setError([]);
        setSelectedFile(false);
        setInputKey(Date.now());
        setIsFilePicked("");
    };

    // Callback per risposta JSON normale
    const onJsonResponse = (data) => {
        setLoading(false);
        okAction(data);
        setSelectedFile(false);
        setInputKey(Date.now());
        setIsFilePicked("");
    };

    // Callback per errori
    const onError = (data) => {
        setLoading(false);
        nokAction(data);
        setSelectedFile(false);
        setInputKey(Date.now());
        setIsFilePicked("");
    };

    const handleSubmission = (controller, tipo) => {
        const formData = new FormData();
        formData.append(tipo, selectedFile);
        formData.append("organizzazione", nomeOrganizzazione)
        formData.append("tipo", tipoOrganizzazione)
        const url = buildUrl(controller)
        
        if (isFilePicked === tipo) {
            setLoading(true);
            
            // Usa il nuovo metodo che gestisce sia JSON che file
            postMultipartWithFileResponse(
                url,
                formData,
                `dati_per_zona_${Date.now()}.xlsx`, // Nome file di default
                onJsonResponse, // Callback per JSON
                onError,        // Callback per errori
                onFileDownload  // Callback per download file
            );
        }
        else {
            const listMessage = ["scegliere un file"];
            setMessage(listMessage);
        }
    };

    if (loading === true) {
        return <SpinnerComp />
    }

    return (
        <div className='main2' role='main'>
            <Container fluid>
                <Talk messaggi={message} warning={warning} errori={error} />
                <h1 className="d-flex justify-content-center">Dati per zona 
                ({nomeOrganizzazione.toLowerCase()}/{tipoOrganizzazione.toLowerCase()})</h1>
                <div className="space divCaricaFile">
                    <Row>
                        <Col xs lg="3">
                            <p className="form-label labelfile ">File dati zona (CSV/Excel/ZIP)</p>
                        </Col>
                        <Col xs lg="7">
                            <input 
                                className="form-control form-control-lg" 
                                id="inputFileDatiSede" 
                                aria-label='File dati sede' 
                                type="file" 
                                name={datiSede} 
                                onChange={changeHandler} 
                                key={inputKey}
                                accept=".csv,.xlsx,.xls,.zip"
                            />
                        </Col>
                        <Col xs lg="2">
                            <Button className="btnGenerale" variant="flat" size="sm" id="carica_dati_sede" onClick={() => handleSubmission(url_dati_sede, datiSede)}>Carica</Button>
                        </Col>
                    </Row>
                </div>
            </Container>
        </div>
    )
}

export default DatiPerSede;